$(function(){
	$('[placeholder]').ahPlaceholder({
		placeholderColor: 'silver',
		placeholderAttr: 'placeholder', 
		likeApple: false
	});
});